import ListItem from '@mui/material/ListItem';
import { ListItemText } from '@mui/material';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import * as PropTypes from 'prop-types';
import React from 'react';

ShoppingItem.propTypes = {
    onClick: PropTypes.func.isRequired,
    shoppingList: PropTypes.shape({
        shoppingListId: PropTypes.string,
        name: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
};

export default function ShoppingItem(props: any) {
    return (
        <ListItem
            onClick={() => props.onClick(props.shoppingList.shoppingListId)}
            divider
        >
            <ListItemText primary={props.shoppingList.name} secondary={`${props.shoppingList.items.length} items`} />
            <ListItemSecondaryAction>
                <IconButton
                    onClick={props.onDelete}
                    aria-label="delete-list"
                >
                    <DeleteIcon />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
}
